import { Common } from "../../../common/src/index";
import { EGroup } from "../../pages/Home";
import TimezoneUtil from "./TimezoneUtil";

// フィルタ処理用
export default class Clusterings {
    /**
     * ルールに基づいてprojectListをクラスタリングします。
     * イメージ {dateName1: [project1-1, project1-2], dateName2: [project2-1, project2-2],...}
     * @param projectList 
     * @param sep クラスタリングルール. ["day", "month", "year"]. default: "year"
     * @returns 
     */
    static clusterByDate(projectList: Common.Project[], sep?: EGroup): {}{
        const displayProjects: {[name: string]: [Common.Project]} = {};
        if(typeof sep === undefined){
            sep = EGroup.DAY;
        }

        switch (sep) {
            case "day":
                // 形式yyyy/MM/ddなので、uploadTimeの加工の必要なし
                projectList.forEach(project => {
                    const uploadTimeDaily = TimezoneUtil.changeLocalTimeFormatString(project.uploadTime).slice(0, 10).replace(/-/g, '/');
                    uploadTimeDaily in displayProjects ?
                    displayProjects[uploadTimeDaily].push(project) :
                    displayProjects[uploadTimeDaily] = [project]})
                break;
            case "month":
                // uploadTimeの加工必要
                projectList.forEach(project => {
                    const uploadTimeMonthly = TimezoneUtil.changeLocalTimeFormatString(project.uploadTime).slice(0, 7).replace(/-/g, '/');
                    uploadTimeMonthly in displayProjects ?
                    displayProjects[uploadTimeMonthly].push(project) :
                    displayProjects[uploadTimeMonthly] = [project]
                })
                break;
            case "year":
                // uploadTimeの加工必要
                projectList.forEach(project => {
                    const uploadTimeYearly = TimezoneUtil.changeLocalTimeFormatString(project.uploadTime).slice(0, 4);
                    uploadTimeYearly in displayProjects ?
                    displayProjects[uploadTimeYearly].push(project) :
                    displayProjects[uploadTimeYearly] = [project]
                })
                break;
            default:
                throw new Error("不正な分類区分です。")
        }

        return displayProjects
    }
}